import { useState } from 'react';
import Reveal from './Reveal';

function Calculator() {
  const [length, setLength] = useState(30);
  const [width, setWidth] = useState(12);
  const [waste, setWaste] = useState(10);

  const area = Math.max(0, Number(length) || 0) * Math.max(0, Number(width) || 0);
  const order = Math.ceil(area * (1 + waste / 100));

  return (
    <section className="bg-sand py-24 md:py-32">
      <div className="wrap grid items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <p className="eyebrow">Plan with confidence</p>
          <h2 className="h-display mt-4 text-5xl md:text-7xl">
            How much paving <em className="text-brick">do you need?</em>
          </h2>
          <p className="mt-6 max-w-md text-sm leading-7 text-stone">
            Enter the rough size of your driveway, patio or deck to estimate coverage. We always confirm exact
            measurements on site.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="bg-white p-8 shadow-[0_30px_70px_rgba(20,17,15,0.1)] md:p-10">
            <div className="grid grid-cols-2 gap-5">
              <label className="grid gap-2 text-xs font-bold uppercase tracking-widest">
                Length (ft)
                <input className="field" type="number" min="0" value={length} onChange={(e) => setLength(e.target.value)} />
              </label>
              <label className="grid gap-2 text-xs font-bold uppercase tracking-widest">
                Width (ft)
                <input className="field" type="number" min="0" value={width} onChange={(e) => setWidth(e.target.value)} />
              </label>
            </div>
            <div className="mt-6">
              <p className="text-xs font-bold uppercase tracking-widest">Extra for cuts & waste</p>
              <div className="mt-3 flex gap-2">
                {[5, 10, 15].map((w) => (
                  <button
                    key={w}
                    type="button"
                    aria-pressed={waste === w}
                    onClick={() => setWaste(w)}
                    className={`flex-1 border py-3 text-sm font-bold transition ${
                      waste === w ? 'border-ink bg-ink text-white' : 'border-ink/15 hover:border-ink'
                    }`}
                  >
                    {w}%
                  </button>
                ))}
              </div>
            </div>
            <div className="mt-8 grid grid-cols-2 gap-px bg-ink/10">
              <div className="bg-bone p-6">
                <p className="text-[10px] font-bold uppercase tracking-widest text-stone">Surface area</p>
                <p className="h-display mt-2 text-5xl">{area.toLocaleString()}<span className="text-xl"> sq ft</span></p>
              </div>
              <div className="bg-bone p-6">
                <p className="text-[10px] font-bold uppercase tracking-widest text-stone">Estimated to order</p>
                <p className="h-display mt-2 text-5xl text-brick">{order.toLocaleString()}<span className="text-xl"> sq ft</span></p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default Calculator;
